import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-bookwise-report',
  templateUrl: './bookwise-report.component.html',
  styleUrls: ['./bookwise-report.component.scss']
})
export class BookwiseReportComponent implements OnInit {

  today = new Date();
  startDate: any;
  endDate: any;

  months: any[] = [];
  // grandTotal: any = {};

  constructor(
    private service: DigisubservicesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    debugger
    this.startDate = this.data?.startDate || new Date();
    this.endDate = this.data?.endDate || new Date();

    this.getReport();
  }

  // ✅ FIXED METHOD
  getReport() {


    const payload = {
      start_date: this.formatDate(this.startDate),
      end_date: this.formatDate(this.endDate)
    };

    this.service.getBusinessReport4(payload).subscribe((res: any) => {

      // 🔥 Adjust based on your API response
      // If your API returns { months: [], grand_total: {} }
      if (res) {
        this.months = res.months || [];
        this.grandTotal = res.grand_total || {};
      }
       this.calculateGrandTotal();

      // 👉 If your API returns { status:'success', data:{} }
      // then use below instead:
      /*
      if (res?.status === 'success') {
        this.months = res.data.months || [];
        this.grandTotal = res.data.grand_total || {};
      }
      */

    }, error => {
      console.error('API Error:', error);
    });
  }
  grandTotal = {
  total_billing_amt: 0,
  total_paid_amt: 0,
  total_credit_amt: 0,
  total_unpaid_amt: 0
};

calculateGrandTotal() {
  this.grandTotal = {
    total_billing_amt: 0,
    total_paid_amt: 0,
    total_credit_amt: 0,
    total_unpaid_amt: 0
  };

  this.months.forEach(month => {
    this.grandTotal.total_billing_amt += month.total_billing_amt || 0;
    this.grandTotal.total_paid_amt += month.total_paid_amt || 0;
    this.grandTotal.total_credit_amt += month.total_credit_amt || 0;
    this.grandTotal.total_unpaid_amt += month.total_unpaid_amt || 0;
  });
}

  formatDate(date: any): string {
    const d = new Date(date);
    return d.toISOString().split('T')[0];
  }

  // ✅ EXPORT
  exportExcel(fileName: string): void {
       const element = document.getElementById('print-section');
       if (!element) return;
   
       try {
         const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
         const wb: XLSX.WorkBook = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
         XLSX.writeFile(wb, fileName + '.xlsx');
       } catch (error) {
         console.error('Export error:', error);
       }
     }

  // ✅ PRINT
 printPageA4(): void {
  const printContent = document.getElementById('print-section'); // ✅ FIXED ID
  if (!printContent) return;

  const WindowPrt = window.open('', '', 'width=900,height=1200');

  WindowPrt!.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Business Report</title>

        <style>
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          @page {
            size: A4 portrait;
            margin: 10mm;
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 10px; /* better fit */
            color: #000;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed;
          }

          th, td {
            border: 1px solid #000;
            padding: 4px;
            word-wrap: break-word;
          }

          thead {
            display: table-header-group;
          }

          tfoot {
            display: table-footer-group;
          }

          tr {
            page-break-inside: avoid;
          }

          .noPrint {
            display: none !important;
          }

          button {
            display: none !important;
          }
        </style>
      </head>

      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  WindowPrt!.document.close();
  WindowPrt!.focus();

  setTimeout(() => {
    WindowPrt!.print();
    WindowPrt!.close();
  }, 500);
}
}